import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import DashboardHSE from "@/pages/DashboardHSE";
import FindingSafety from "@/pages/FindingSafety";
import Finding5S from "@/pages/Finding5S";
import Incident from "@/pages/Incident";
import InputFinding from "@/pages/InputFinding";
import MonitoringTraining from "@/pages/MonitoringTraining";
import MonitoringSimper from "@/pages/MonitoringSimper";
import LIFCCV from "@/pages/LIFCCV";
import LaggingLeading from "@/pages/LaggingLeading";
import DashboardAbsensi from "@/pages/DashboardAbsensi";
import InputAbsensi from "@/pages/InputAbsensi";
import DokumenAdministratif from "@/pages/DokumenAdministratif";
import KelolaAkun from "@/pages/KelolaAkun";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardHSE />} />
        <Route path="/finding-safety" element={<FindingSafety />} />
        <Route path="/finding-5s" element={<Finding5S />} />
        <Route path="/incident" element={<Incident />} />
        <Route path="/lagging-leading" element={<LaggingLeading />} />
        <Route path="/input-finding" element={<InputFinding />} />
        <Route path="/lif-ccv" element={<LIFCCV />} />
        <Route path="/monitoring-training" element={<MonitoringTraining />} />
        <Route path="/monitoring-simper" element={<MonitoringSimper />} />
        <Route path="/dashboard-absensi" element={<DashboardAbsensi />} />
        <Route path="/input-absensi" element={<InputAbsensi />} />
        <Route path="/dokumen" element={<DokumenAdministratif />} />
        <Route path="/kelola-akun" element={<KelolaAkun />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
